// extracted by mini-css-extract-plugin
module.exports = {"twitterIcon":"_2Wc8k"};